<template>
  <Reference
    :id="value && value.id"
    :value="value"
    :label="label || 'Продукти'"
    placeholder="Введіть найменування або артикул продукту"
    :items.sync="items"
    :total-items="totalItems"
    component-name="Product"
    data-test="product-select"
    @input="$emit('input', $event)"
    @getItems="getItems"
  />
</template>

<script>
import * as productsApi from "@/backend/productsApi.js";
import Reference from "@/components/Reference";

export default {
  components: {
    Reference,
  },
  props: {
    label: {
      type: String,
      default: "Продукти",
    },
    value: {
      type: Object,
    }
  },
  data: () => ({
    items: [],
    totalItems: 0,
  }),
  methods: {
    async getItems({ currentPage, perPage, search }) {
      const { result, totalItems } = await productsApi.selectProduct(
        currentPage,
        perPage,
        search
      );
      this.items = [...this.items, ...result];
      this.totalItems = totalItems;
    },
  },
};
</script>
